import React from 'react';
import { AwardIcon, BookOpenIcon, EyeIcon, RouteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  route: RouteIcon,
  book: BookOpenIcon,
  eye: EyeIcon,
  award: AwardIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-charcoal" data-id="element-16" data-mp="3nohvqazavswc">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="3nmyi6s513vy9">
        <h2 id="beneficios" className="font-anton text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-18" data-mp="38qpgljxo16io">
          ¿Qué puede cambiar cuando empezás?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/80" data-id="element-19" data-mp="2zsx4spr5kh01">
          Aprender a fabricar muebles puede abrir nuevas posibilidades.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="xzpope3ptvd3">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border border-white/10 bg-white/5 p-2.5 text-left" data-id="element-21" data-mp="2bf5x8wnpzw4x" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-cta" data-id="element-22" data-mp="2l3xo11h1oae9">
                  <Icon size={15} className="text-charcoal" data-id="element-23" data-mp="2g7794hgz7kuf" />
                </span>
                <div data-id="element-24" data-mp="1shcupvh0do82">
                  <h3 className="font-display text-sm font-extrabold uppercase leading-tight text-cta" data-id="element-25" data-mp="1sgtkz21ii654">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-white/80 sm:text-sm" data-id="element-26" data-mp="22erb5v2xmd0d">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}